import React, { useState } from "react";
// --- LOGO IMPORTS ---
import logoIcon from "../assets/images/logo.png"; 
import logoText from "../assets/images/ente tm txt.png"; 

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* Updated BG to Prussian Blue and Border to Steel Blue */}
      <header className="fixed top-0 left-0 w-full z-50 flex items-center justify-between px-6 py-4 bg-[#003049]/90 backdrop-blur-md shadow-lg border-b border-[#457B9D]">
        {/* Logo Section */}
        <div className="flex items-center gap-2">
          <div className="font-bold flex items-center justify-center">
            <img 
              src={logoIcon} 
              alt="whitelogo" 
              style={{ width: "45px", height: "45px" }} 
              className="object-contain"
            />
          </div>
          {/* Centered text vertically with icon */}
          <div className="font-bold flex items-center justify-center mt-2">
            <img 
              src={logoText} 
              alt="logo_text" 
              style={{ height: "55px", width: "auto" }} 
              className="object-contain"
            />
          </div>
        </div>
        
        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-8 text-gray-200 font-medium items-center">
          <a href="/" className="hover:text-[#D1D1D1] transition-colors duration-300">Home</a>
          <a href="/about" className="hover:text-[#D1D1D1] transition-colors duration-300">About Us</a>
          <a href="/services" className="hover:text-[#D1D1D1] transition-colors duration-300">Services</a>
          <a href="/gallery" className="hover:text-[#D1D1D1] transition-colors duration-300">Gallery</a>
          <a href="/courses" className="hover:text-[#D1D1D1] transition-colors duration-300">Courses</a>
          <a href="/contact_us" className="hover:text-[#D1D1D1] transition-colors duration-300">Contact Us</a>
          <a href="/bookslot" className="text-[#D1D1D1] border border-[#D1D1D1] px-4 py-2 rounded-md hover:bg-[#D1D1D1] hover:text-[#003049] transition-all duration-300 shadow-[0_0_10px_rgba(209,209,209,0.2)] hover:shadow-[0_0_15px_rgba(209,209,209,0.5)]">Book your Slot</a>
        </nav>
        
        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-[#D1D1D1] text-2xl"
          onClick={() => setMenuOpen(true)}
        >
          ☰
        </button>
      </header>

      {/* Side Nav Mobile Menu */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-[#002639] shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        } md:hidden border-r border-[#457B9D]`}
        style={{ willChange: "transform" }}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#457B9D]">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 font-bold flex items-center justify-center">
               <img src={logoIcon} alt="logo" className="w-full h-full object-contain"/>
            </div>
            <div className="-mt-1">
               <img src={logoText} alt="text" style={{ height: "24px", width: "auto" }} />
            </div>
          </div>
          <button
            className="text-gray-400 hover:text-white text-2xl"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>
        <nav className="flex flex-col px-6 py-4 space-y-4 text-gray-300 font-medium">
          <a href="/" className="hover:text-[#D1D1D1] transition-colors" onClick={() => setMenuOpen(false)}>Home</a>
          <a href="/about" className="hover:text-[#D1D1D1] transition-colors" onClick={() => setMenuOpen(false)}>About Us</a>
          <a href="/services" className="hover:text-[#D1D1D1] transition-colors" onClick={() => setMenuOpen(false)}>Services</a>
          <a href="/contact_us" className="hover:text-[#D1D1D1] transition-colors" onClick={() => setMenuOpen(false)}>Contact Us</a>
          <a href="/courses" className="hover:text-[#D1D1D1] transition-colors" onClick={() => setMenuOpen(false)}>Courses</a>
          {/*<a href="/workshop" className="hover:text-[#D1D1D1] transition-colors" onClick={() => setMenuOpen(false)}>Workshop</a>*/}
          <a href="/bookslot" className="text-[#D1D1D1] font-bold" onClick={() => setMenuOpen(false)}>Book your Slot</a>        
        </nav>
      </div>
      
      {/* Overlay */}
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 md:hidden"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </>
  );
}

export default Navbar;
